define(
({
  "load_error": "加载错误",
  "description": "请求未正确完成。您应该确保您的订单已保存，然后刷新此页面。"
})
);
